import { AxiosError } from 'axios';
import React, { useEffect } from 'react';
import { ButtonOne } from '../../../../../components/ButtonOne/ButtonOne.component';
import { uploadExamSheetFile } from '../../../../../services/exams/sessions/sessions.service';
import { useStyles } from '../../../../styles';
import { SessionImagesProps, UploadingFile, Error, UploadState } from './SessionImagesFileUpload.types';
import AddIcon from '@mui/icons-material/Add';
import { FileType } from '../../../../../utils/fileProcessing';

const errorInfo = {
  wrongName: 'Nazwa wybranego pliku nie spełnia wymagań. Przed ponownym importem popraw nazwę pliku',
  duplicateName: 'Wybrany plik jest już zapisany. Wybierz inny plik',
  uploadError: 'Wystąpił błąd podczas ładowania',
  formatError: 'Format pliku jest nieprawidłowy',
};

class Validator {
  static validName = new RegExp('^([0-9][1-9]|[1-9][0-9])_.*');
  static validType: FileType = 'image/png';
  file;
  private _error: Error = { info: 'no error' };
  constructor(file: File) {
    this.file = file;
  }

  valid(): boolean {
    const pageNumberString = this.file.name.split('_')[0];
    const pageNumber = +pageNumberString;
    if (!Validator.validName.test(this.file.name)) {
      this._error = {
        info: errorInfo.wrongName,
      };
      return false;
    }
    return true;
  }

  validType(): boolean {
    if (Validator.validType !== this.file.type) {
      this._error = {
        info: errorInfo.formatError,
      };
      return false;
    }
    return true;
  }

  get error(): Error {
    return this._error;
  }
}

export const SessionsImagesFileUpload: React.FC<SessionImagesProps> = ({
  setFiles,
  examSheetId,
  variant,
  isConfigured,
  abortController,
}) => {
  const classes = useStyles();

  const uploadHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileList: FileList | null = event.target.files;

    if (fileList === null) {
      return;
    }

    const filesToUpload: UploadingFile[] = Array.from(fileList).map((file: File) => {
      const validator = new Validator(file);
      if (validator.validType() && validator.valid()) {
        return {
          isUploading: false,
          name: file.name,
          htmlInputFile: file,
        };
      } else {
        return {
          isUploading: true,
          name: file.name,
          htmlInputFile: file,
          error: validator.error,
        };
      }
    });

    filesToUpload.sort();

    filesToUpload.forEach((fileToUpload) => {
      setFiles([...filesToUpload]);
      uploadExamSheetFile(examSheetId, fileToUpload.htmlInputFile, abortController?.current?.signal)
        .then((res: any) => {
          if (res.data.uploadState === UploadState.SUCCESS) {
            fileToUpload.isUploading = true;
          } else if (res.data.uploadState === UploadState.FILENAMEALREADYUSED) {
            fileToUpload.isUploading = true;
            fileToUpload.error = { info: errorInfo.duplicateName };
          } else {
            fileToUpload.isUploading = false;
            fileToUpload.error = {
              info: errorInfo.uploadError,
            };
          }
          setFiles([...filesToUpload]);
        })
        .catch((err: AxiosError<UploadingFile>) => {
          console.error(err);
        });
    });
  };

  const clearInputValue = (event: React.MouseEvent<HTMLInputElement>) => {
    event.currentTarget.value = '';
  };

  return (
    <div>
      {variant === 'blue' && (
        <div>
          <input
            type="file"
            multiple
            className={classes.uploadInput}
            accept=".png"
            onChange={uploadHandler}
            onClick={clearInputValue}
            style={isConfigured ? { visibility: 'hidden' } : { visibility: 'visible' }}
          />
          <ButtonOne
            className={classes.primary && classes.uploadButton}
            variant="contained"
            aria-label="Dodaj Wzorcowy Arkusz"
            disabled={isConfigured}
            startIcon={<AddIcon style={{ fontSize: 14 }} />}
          >
            Dodaj Wzorcowy Arkusz
          </ButtonOne>
        </div>
      )}
      {variant === 'green' && (
        <div>
          <input
            type="file"
            multiple
            className={classes.uploadInput}
            accept=".png"
            onChange={uploadHandler}
            onClick={clearInputValue}
            style={
              isConfigured
                ? { display: 'none' }
                : { display: 'flex', width: '90px', marginTop: '0', position: 'absolute', right: '30px' }
            }
          />
          <ButtonOne
            className={classes.primary}
            style={{
              backgroundColor: 'green',
              width: '90px',
              marginTop: '0px',
              zIndex: 1,
              position: 'absolute',
              right: '30px',
            }}
            variant="contained"
            aria-label="Dodaj Wzorcowy Arkusz"
            disabled={isConfigured}
            startIcon={<AddIcon style={{ fontSize: 14 }} />}
          >
            Dodaj
          </ButtonOne>
        </div>
      )}
    </div>
  );
};
